document.addEventListener("DOMContentLoaded", () => {
  if (document.documentElement.clientWidth <= 768) {
    const filterButton = document.querySelector("#filter-button");
    const filterBlock = document.querySelector(".filter-block");
    let check = false;
    if (filterButton) {
      const filterBlockHeight = filterBlock.offsetHeight;
      filterBlock.style = `height: 0px`;
      filterButton.addEventListener("click", () => {
        filterBlock.classList.toggle("view");
        !check
          ? (filterBlock.style = `height: ${filterBlockHeight}px`)
          : (filterBlock.style = `height: 0px`);
        check = !check;
      });
    }

    const sort = document.querySelector(".active-sort");
    const dropdown = document.querySelector(
      ".category__order .uk-dropdown-small"
    );
    if (sort) {
      sort.addEventListener("click", () => {
        setTimeout(() => {
          dropdown.style = `width: ${sort.offsetWidth - 1}px !important;`;
        }, 350);
      });
      window.addEventListener("resize", () => {
        setTimeout(() => {
          dropdown.style = `width: ${sort.offsetWidth - 1}px !important;`;
        }, 350);
      });
    }
  }
  const categoryPagination = document.querySelector(".category .pagination ul");
  if (categoryPagination) {
    categoryPagination.classList.add("uk-pagination");
    const category = document.querySelector(".category");

    let observer = new MutationObserver(() => {
      const categoryPagination = document.querySelector(
        ".category .pagination ul"
      );

      if (categoryPagination) {
        categoryPagination.classList.add("uk-pagination");
      }
    });

    observer.observe(category, {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });
  }
  const tsvetLbl =
    document.querySelector("#tsvet-lbl") ||
    document.querySelector("#kolor-lbl");
  if (tsvetLbl) {
    tsvetLbl.parentElement.parentElement.classList.add(
      "control-group-tsvetLbl"
    );
  }
  const mainForm = document.querySelector("#main-form");
  if (mainForm) {
    document.querySelector("#footer").style = `background: white;`;
    const popularLink = document.querySelector(
      `[data-id="template-CDYqyViW#2-0-1-0"] a`
    );
    const newsLink = document.querySelector(`#news-link a`);
    if (popularLink) {
      popularLink.classList.add("popular-link");
    }
    if (newsLink) {
      newsLink.classList.add("popular-link");
    }
    if (document.documentElement.clientWidth <= 768) {
      if (popularLink) {
        popularLink.innerText = "";
      }
      if (newsLink) {
        newsLink.innerText = "";
      }
    }
  }

  const headerWrapper = document.querySelector("#desktop-arrow-up");
  let scrollTop;
  document.addEventListener("scroll", () => {
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= 100) {
      headerWrapper.classList.remove("hidden-arrow-opacity");
    } else {
      headerWrapper.classList.add("hidden-arrow-opacity");
    }
  });

  const pgPrev = document.querySelector("#pg-article .uk-pagination-previous");
  const pgNext = document.querySelector("#pg-article .uk-pagination-next");
  if (pgPrev) {
    pgPrev.parentElement.classList.add("uk-button-danger", "pg-prev");
    if (document.documentElement.clientWidth <= 768) {
      pgPrev.parentElement.innerText = "";
    } else {
      pgPrev.parentElement.innerText = "Предыдущая статья";
    }
  }
  if (pgNext) {
    pgNext.parentElement.classList.add("uk-button-danger");
    if (document.documentElement.clientWidth <= 768) {
      pgNext.parentElement.innerText = "";
    } else {
      pgNext.parentElement.innerText = "Следующая статья";
    }
  }

  if (document.documentElement.clientWidth <= 960) {
    const reviews = document.querySelectorAll("#radicalreviews .uk-list li");
    if (reviews && reviews.length === 1) {
      reviews[0].querySelector(".uk-card").style = `width: 100%;`;
    }
  }

  const categoryPage = document.querySelector(".category");
  if (categoryPage) {
    const h1Text = categoryPage.querySelector("h1").innerText;
    const collectionBlock = categoryPage.querySelectorAll(
      ".filter-block .accordion-item"
    )[2];
    const masCollect = collectionBlock.querySelectorAll(".form-check");
    masCollect.forEach((item) => {
      if (
        item.querySelector(".form-check-label").innerHTML.trim() ===
        h1Text.trim()
      ) {
        item.querySelector(".form-check-input").setAttribute("checked", "true");
      }
    });
  }

  const checkColor = () => {
    const input = document.querySelector(".color_block");
    const colorArray = input.querySelectorAll(".color_name");
    if (input) {
      input.addEventListener("input", (e) => {
        console.log(e.target.value);
        if (e.target.value === "") {
          colorArray.forEach((item) => {
            item.parentElement.classList.remove("uk-hidden");
          });
        } else {
          colorArray.forEach((item) => {
            if (
              String(item.innerHTML)
                .toLowerCase()
                .includes(String(e.target.value).toLowerCase())
            ) {
              item.parentElement.classList.remove("uk-hidden");
            } else {
              item.parentElement.classList.add("uk-hidden");
            }
          });
        }
      });
    }
  };

  const targetElement = document.querySelector('[radicalmart-ajax="products"]');
  if (targetElement) {
    checkColor();

    const observer = new MutationObserver(function (mutations) {
      checkColor();
    });

    const config = {
      attributes: true,
      childList: true,
      subtree: true,
    };

    observer.observe(targetElement, config);
  }
});
